<template>
    <b-form-group :label="label"
                  :label-cols="labelCols"
                  :content-cols="contentCols"
                  :label-cols-sm="labelSize.sm"
                  :label-cols-md="labelSize.md"
                  :label-cols-lg="labelSize.lg"
                  :label-cols-xl="labelSize.xl"
                  :content-cols-sm="contentSize.sm"
                  :content-cols-md="contentSize.md"
                  :content-cols-lg="contentSize.lg"
                  :content-cols-xl="contentSize.xl">
        <b-form-radio-group v-model="localValue" buttons size="sm">
            <template v-for="option in radioOptions">
                <b-form-radio :value="option.value"
                              :key="option.html"
                              @change="onChange"
                              :button-variant="option.variant">
                    <span v-html="option.html"></span>
                </b-form-radio>
            </template>
        </b-form-radio-group>
    </b-form-group>
</template>

<script>
export default {
    name: "CustomRadioButtonGroup",
    props: {
        value: {
            type: Boolean,
            default: null,
            required: false
        },
        label: {
            type: String,
            default: '',
            required: false
        },
        labelCols: {
            type: [Number, Boolean],
            default: 0,
            required: false
        },
        contentCols: {
            type: [Number, Boolean],
            default: 0,
            required: false
        },
        labelSize: {
            type: Object,
            default: function() {
                return {
                    'sm': 0,
                    'md': 0,
                    'lg': 0,
                    'xl': 0,
                }
            },
            required: false
        },
        contentSize: {
            type: Object,
            default: function() {
                return {
                    'sm': 0,
                    'md': 0,
                    'lg': 0,
                    'xl': 0,
                }
            },
            required: false
        }
    },
    data() {
        return {
            localValue: this.value,
            radioOptions: [
                {html: '<i class="fas fa-fw fa-ban"></i>', value: false, variant: 'outline-danger'},
                {html: '<i class="fas fa-fw fa-question"></i>', value: null, variant: 'outline-secondary'},
                {html: '<i class="fas fa-fw fa-check"></i>', value: true, variant: 'outline-success'},
            ]
        }
    },
    methods: {
        onChange(value) {
            this.$emit('input', value);
        }
    },
    watch: {
            value: {
                deep: true,
                immediate: true,
                handler: function (val) {
                    this.localValue = val;
                }
            }
        },
}
</script>

<style scoped>
</style>
